import { render } from "./footerCom3.vue?vue&type=template&id=57521ff5&scoped=true"
const script = {}

import "./footerCom3.vue?vue&type=style&index=0&id=57521ff5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57521ff5"]])

export default __exports__